export default __webpack_public_path__ + "static/media/taxi-1.940d6fb0.png";